import React from 'react';

export default function SalarySlipModal({ show, slipHTML, onClose, onPrint }) {
  if (!show) return null;

  return (
    <div className="pr-modal-backdrop">
      <div className="pr-modal">
        <div className="pr-modal-actions">
          <button className="pr-btn blue" onClick={onPrint}>Print</button>
          <button className="pr-btn coral" onClick={onClose}>Close</button>
        </div>

        <div
          dangerouslySetInnerHTML={{ __html: slipHTML }}
          style={{ marginTop: 50 }}
        />
        <div id="print-area" style={{ display: 'none' }} />
      </div>
    </div>
  );
}
